import {Button, Col, Form, Input, Row, Tooltip, Typography} from 'antd';
import {TranslationOutlined, InfoCircleOutlined} from '@ant-design/icons';

const CatalogLocalizedFieldsSection = ({
  title,
  name,
  requiredRules,
  multiline = false,
  enableTranslate = false,
  loadingTranslation = false,
  onTranslate,
}) => {
  const FieldComponent = multiline ? Input.TextArea : Input;
  const englishValue = Form.useWatch([name, 'EN']);
  const canTranslate = `${englishValue ?? ''}`.trim().length > 5;

  return (
    <div style={{marginBottom: 24}}>
      <Typography.Title level={5} style={{marginBottom: 16, marginTop: 0}}>
        {title}
      </Typography.Title>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={
              <span>
                English&nbsp;
                <Tooltip
                  title={`The ${title.toLowerCase()} that users will see if their language is set to English.`}>
                  <InfoCircleOutlined style={{color: '#8b82a7'}} />
                </Tooltip>
              </span>
            }
            name={[name, 'EN']}
            rules={requiredRules || []}>
            <FieldComponent
              rows={multiline ? 3 : undefined}
              placeholder={`Enter ${title.toLowerCase()} in English`}
            />
          </Form.Item>
          {enableTranslate ? (
            <Button
              type="default"
              icon={<TranslationOutlined />}
              disabled={loadingTranslation || !canTranslate}
              title={
                canTranslate
                  ? 'Translate English to French via AI'
                  : 'Enter at least 6 characters in English to translate'
              }
              onClick={() => onTranslate?.(name)}>
              Auto-Translate to French
            </Button>
          ) : null}
        </Col>
        <Col span={12}>
          <Form.Item
            label={
              <span>
                French&nbsp;
                <Tooltip
                  title={`The ${title.toLowerCase()} that users will see if their language is set to French.`}>
                  <InfoCircleOutlined style={{color: '#8b82a7'}} />
                </Tooltip>
              </span>
            }
            name={[name, 'FR']}
            rules={requiredRules || []}>
            <FieldComponent
              rows={multiline ? 3 : undefined}
              placeholder={`Enter ${title.toLowerCase()} in French`}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default CatalogLocalizedFieldsSection;
